module.exports = __webpack_public_path__ + "static/media/motor-car-accident.b99f9435.svg";